import { RootState } from 'store/rootReducer';

export const NavigationBarContentSelector = (state: RootState) => state.content.navigationBar;
